import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-executive-list',
  templateUrl: './business-executive-list.component.html',
  styleUrls: ['./business-executive-list.component.css']
})
export class BusinessExecutiveListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
